import { c as _c } from "react/compiler-runtime";
import React, { PropsWithChildren } from "react";
import styles from "./GiveButton.module.scss";
import { usePlausible } from "next-plausible";
export const GiveButton: React.FC<PropsWithChildren<{
  color: string;
  inverted: boolean;
  onClick: () => void;
  title: string;
}>> = t0 => {
  const $ = _c(12);
  const {
    children,
    color,
    inverted,
    title,
    onClick
  } = t0;
  const plausible = usePlausible();
  let t1;
  if ($[0] !== onClick || $[1] !== plausible) {
    t1 = () => {
      plausible("OpenDonationWidget", {
        props: {
          page: window.location.pathname
        }
      });
      onClick();
    };
    $[0] = onClick;
    $[1] = plausible;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const handleClick = t1;
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {};
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let customStyles = t2;
  if (color) {
    let t3;
    if ($[4] !== color) {
      t3 = {
        "--accent-color": color
      };
      $[4] = color;
      $[5] = t3;
    } else {
      t3 = $[5];
    }
    customStyles = t3 as React.CSSProperties;
  }
  const t3 = `${styles.givebutton} ${inverted ? styles.givebuttoninverted : ""}`;
  let t4;
  if ($[6] !== children || $[7] !== customStyles || $[8] !== handleClick || $[9] !== t3 || $[10] !== title) {
    t4 = <button style={customStyles} className={t3} title={title} onClick={handleClick} data-cy="gi-button">{children}</button>;
    $[6] = children;
    $[7] = customStyles;
    $[8] = handleClick;
    $[9] = t3;
    $[10] = title;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  return t4;
};